import { useContext } from 'react';
import { AuthContext } from '../context';

export const useAuthContext = () => {
  const context = useContext(AuthContext);

  if (!context)
    throw new Error(
      'useAuthContext personality-analysis-context must be use inside AuthProvider'
    );

  return context;
};
